/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setBrandCheckoutNotes} from '../api'

export const useMutationSetBrandCheckoutNotes = createReactQueryMutationHook('setBrandCheckoutNotes', setBrandCheckoutNotes)
